import {KeyboardEvent as SyntheticKeyboardEvent} from 'react';

export const eventPrevented = (
    e: KeyboardEvent | SyntheticKeyboardEvent<HTMLElement>,
    stopPropagation?: boolean
) => {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
    }
};
